import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["master", "slave"]

    declare readonly masterTarget: HTMLInputElement
    declare readonly slaveTargets: HTMLInputElement[]

    toggle() {
        const isChecked = this.masterTarget.checked
        this.slaveTargets.forEach((checkbox) => {
            checkbox.checked = isChecked
        })
    }
}
